var _linearGradient, _path, _linearGradient2, _circle, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomeStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: -1364.508,
    y1: -724.509,
    x2: -1363.508,
    y2: -724.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M114.673 37.737h8.347v12.094H76.849V37.737h7.979M84.828 37.737a12.149 12.149 0 01-.165-1.985c0-7.359 6.749-13.324 15.087-13.324 8.328 0 15.087 5.965 15.087 13.324 0 .678-.058 1.336-.165 1.985"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 93.463,
    y1: 33.653,
    x2: 106.037,
    y2: 33.653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.75,
    cy: 33.653,
    r: 5.037,
    fill: "none",
    stroke: "url(#SVGID_1_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 73.089,
    y1: 96.535,
    x2: 125.995,
    y2: 96.535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M74.339 96.535h50.406"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 73.089,
    y1: 106.741,
    x2: 125.995,
    y2: 106.741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M74.339 106.741h50.406"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 73.089,
    y1: 116.948,
    x2: 125.995,
    y2: 116.948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M74.339 116.948h50.406"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 73.089,
    y1: 127.155,
    x2: 125.995,
    y2: 127.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M74.339 127.155h50.406"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 79.684,
    y1: 80.125,
    x2: 89.408,
    y2: 80.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.934 63.716h7.223v32.819h-7.223z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 95.073,
    y1: 86.268,
    x2: 104.796,
    y2: 86.268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M96.323 76.001h7.223v20.534h-7.223z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e",
    gradientUnits: "userSpaceOnUse",
    x1: 110.776,
    y1: 91.019,
    x2: 120.499,
    y2: 91.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_6a667467074bc4b62b2b8ae5e7d6761c7e435e8351d451bebcd913474ae14b0e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M112.026 85.504h7.223v11.031h-7.223z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M123.091 43.672h10.998c2.314 0 4.189 2.077 4.189 4.639v90.652c0 2.562-1.875 4.639-4.189 4.639H64.943c-2.314 0-4.189-2.077-4.189-4.639V48.312c0-2.562 1.875-4.639 4.189-4.639H76.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeStatement);
export default __webpack_public_path__ + "static/media/incomeStatement.a01225280a6868b83480b81ba45b5d11.svg";
export { ForwardRef as ReactComponent };